import React, { useState } from 'react';
import { Drawer } from 'antd';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LogoFull, Menu, CloseIcon, User, ChevronRight, ChevronLeft, HouseCertificate, EmailRound, CopyRound, TwitterRound, FacebookRound, LinkedinRound } from '../../assets/icons';
import './AccountNavMobile.scss';
import LogoutModal from '../LogoutModal/LogoutModal';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { toastNotify } from '../../utils/toastNotify';
import { copyTextToClipboard } from '../../utils';
import { getReferralLink } from '../../services/authApi/authApi';
import throttle from 'lodash/throttle'
import { handleSignupButtonNavigation, handleLoginButtonNavigation } from '../../utils/handleLoginSignupRedirection';
import useSecondaryMarketEligibility from '../../Hooks/useSecondaryMarketEligibility';

const handleKeyActivate = (callback) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    callback(e);
  }
};

// Created once at module scope — creating this per-render would reset the throttle's
// internal timer on every render, defeating throttling entirely.
const throttledReferralLink = throttle(getReferralLink, 3000);

const AccountNavMobile = (props) => {
  const { setSideBarName } = props;
  const [open, setOpen] = useState(false);
  const [openAccountDrawer, setOpenAccountDrawer] = useState(false);
  const [openMarketDrawer, setOpenMarketDrawer] = useState(false);
  const [openReferalDrawer, setOpenReferalDrawer] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const userProfileData = useSelector((state) => state.userData.userData);
  const navigate = useNavigate();
  const location = useLocation();
  const { isEntityRestricted } = useSecondaryMarketEligibility();
  const isLoggedIn = !!localStorage.getItem('access_token');
  const closeDrawer = () => {
    setOpen(false);
    setOpenAccountDrawer(false);
    setOpenMarketDrawer(false);
    setOpenReferalDrawer(false)
  };
  let referallink = localStorage.getItem('referralLink') || '';
  const bodyText = `Use the referral link below to receive $50 worth of shares on your initial investment into any Realbricks property.
  Get started now: `;

  const handleOnreferalClick = async () => {
    // try {
    //   setOpenReferalDrawer(true)
    //   let link = localStorage.getItem('referralLink');
    //   if(!link) {
    //     const token = localStorage.getItem('access_token');
    //     link = await getReferralLink(token);
    //     localStorage.setItem('referralLink', link.data.referralLink);
    //   }
    // } catch (error) {
    //   // Handle error
    //   console.error('Error fetching referral link:', error);
    // }
    try {
      const link = localStorage.getItem('referralLink');
      const token = localStorage.getItem('access_token');
      if (!link) {
        navigate('/account/affiliate-program');
        if (location.pathname === '/account/affiliate-program') {
          toastNotify('error', 'Complete Referral Program Process');
          return;
        }
        setOpenReferalDrawer(false);
        const response = await getReferralLink(token);
        const { referralLink, hasInvested, agreementAccepted, profileCompleted } = response.data;

        if (hasInvested && agreementAccepted && profileCompleted) {
          localStorage.setItem('referralLink', referralLink);
          return;
        } else {
          localStorage.removeItem('referralLink')
        }
        return;
      }

      // If all conditions are passed, open the popover
      const response = await throttledReferralLink(token);
      const { hasInvested, agreementAccepted, profileCompleted } = response.data;
      if (hasInvested && agreementAccepted && profileCompleted) {

        setOpenReferalDrawer(true);
      }else{
        navigate('/account/affiliate-program');
        if (location.pathname === '/account/affiliate-program') {
          toastNotify('error', 'Complete Referral Program Process');
          return;
        }
      }
    } catch (error) {
      toastNotify('error',error?.response?.data?.message)
    }
  };

  return (
    <>
      <nav className='navmob'>
        <div className='navmob__logo'>
        {Object.keys(userProfileData).length > 0 ? (
          <Link to='/'>
            <LogoFull color='#1a1519' />
          </Link>
        ) : (
          <a href='https://www.realbricks.com' target='_blank' rel='noreferrer'>
            <LogoFull color='#1a1519' />
          </a>
        )}
        </div>
        <div
          className='navmob__ham'
          onClick={() => setOpen(true)}
          onKeyDown={handleKeyActivate(() => setOpen(true))}
          role='button'
          tabIndex={0}
        >
          <Menu />
        </div>
      </nav>
      <Drawer className='navdrawer' width={400} headerStyle={{ display: 'none' }} onClose={() => setOpen(false)} open={open}>
        <div className='mb-32 navmob'>
          <div className='navmob__logo'>
            <LogoFull />
          </div>
          <div
            className='navmob__ham'
            onClick={closeDrawer}
            onKeyDown={handleKeyActivate(closeDrawer)}
            role='button'
            tabIndex={0}
          >
            <CloseIcon size='30' />
          </div>
        </div>
        <ul className='navdrawer__list'>
          {!!Object.keys(userProfileData)?.length && localStorage.getItem('access_token') && (
            <li
              className='navdrawer__list__item'
              onClick={() => setOpenAccountDrawer(true)}
              onKeyDown={handleKeyActivate(() => setOpenAccountDrawer(true))}
              role='button'
              tabIndex={0}
            >
              <span className='subhead-3'>
                <User size='20' color='#8A4743' verticalAlign='-4px' marginRight='5px' /> {`Hi, ${userProfileData?.firstName}`}
              </span>
              <ChevronRight />
            </li>
          )}
          {(!Object.keys(userProfileData)?.length || !localStorage.getItem('access_token')) && (
            <li className='navdrawer__list__item'>
              <a href='/login' onClick={handleLoginButtonNavigation} className='subhead-2'>
                Log in
              </a>
            </li>
          )}
          {(!Object.keys(userProfileData)?.length || !localStorage.getItem('access_token')) && (
            <li className='navdrawer__list__item'>
              <a href='/sign-upAuth' onClick={handleSignupButtonNavigation} className='subhead-2'>
                Sign up
              </a>
            </li>
          )}
          <li
            className='navdrawer__list__item'
            onClick={() => setOpenMarketDrawer(true)}
            onKeyDown={handleKeyActivate(() => setOpenMarketDrawer(true))}
            role='button'
            tabIndex={0}
          >
            <Link to='/' className='subhead-2' onClick={(e) => e.preventDefault()}>
              Invest
            </Link>
          </li>
          {!!Object.keys(userProfileData)?.length && (
            <li className='navdrawer__list__item'>
              <Link to='/portfolio' className='subhead-2'>
                Portfolio
              </Link>
            </li>
          )}
          <li className='navdrawer__list__item'>
            <a href='https://www.realbricks.com/learn' target='_self' className='subhead-2' rel='noreferrer'>
              Learn
            </a>
          </li>
          {!!Object.keys(userProfileData)?.length && (
            <li className='navdrawer__list__item'>
              <Link to='/marketplace/favorites' className='subhead-2'>
                Favorites
              </Link>
            </li>
          )}
          {!!Object.keys(userProfileData)?.length && (
            <li
              className='navdrawer__list__item'
              onClick={handleOnreferalClick}
              onKeyDown={handleKeyActivate(handleOnreferalClick)}
              role='button'
              tabIndex={0}
            >
              <span className='subhead-2'>Referral</span>
              <ChevronRight />
            </li>
          )}
        </ul>
      </Drawer>
      <Drawer
        className='navdrawer'
        width={400}
        headerStyle={{ display: 'none' }}
        onClose={() => setOpenAccountDrawer(false)}
        open={openAccountDrawer}
      >
        <div className='account'>
          <div className='mb-32 navmob'>
            <div
              className='cursor-pointer text-terracotta fw-600 fz-16 navmb__back'
              onClick={() => setOpenAccountDrawer(false)}
              onKeyDown={handleKeyActivate(() => setOpenAccountDrawer(false))}
              role='button'
              tabIndex={0}
            >
              <ChevronLeft marginRight='5px' verticalAlign='-6px' />
              Back
            </div>
            <div
              className='navmob__ham'
              onClick={closeDrawer}
              onKeyDown={handleKeyActivate(closeDrawer)}
              role='button'
              tabIndex={0}
            >
              <CloseIcon size='30' />
            </div>
          </div>
          <ul className='account__list'>
            <p className='subhead-2 text-taupe-80'>My Account</p>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Profile');
                }}
                to='/account'
              >
                Profile
              </Link>
            </li>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Balances & Transactions');
                }}
                to='/account/transactions'
              >
                Balances & Transactions
              </Link>
            </li>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Payment Methods');
                }}
                to='/account/payment'
              >
                Payment Methods
              </Link>
            </li>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Documents');
                }}
                to='/account/documents'
              >
                Documents
              </Link>
            </li>
            <li className='mb-32 account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Settings');
                }}
                to='/account/settings'
              >
                Settings
              </Link>
            </li>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Help Center');
                }}
                to='/account/help-center'
              >
                Help Center
              </Link>
            </li>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Legal');
                }}
                to='/account/legal'
              >
                Legal
              </Link>
            </li>
            
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Referral Program');
                }}
                to='/account/affiliate-program'
              > 
                 Referral Program
              </Link>
            </li>
            
            <li
              className='account__list__item cursor-pointer'
              onClick={() => setLogoutModal(true)}
              onKeyDown={handleKeyActivate(() => setLogoutModal(true))}
              role='button'
              tabIndex={0}
            >
              <span>Log out</span>
            </li>
          </ul>
        </div>
      </Drawer>
      <Drawer className='navdrawer' width={400} headerStyle={{ display: 'none' }} onClose={() => setOpenMarketDrawer(false)} open={openMarketDrawer}>
        <div className='market'>
          <div className='mb-32 navmob'>
            <div
              className='cursor-pointer text-terracotta fw-600 fz-16 navmb__back'
              onClick={() => setOpenMarketDrawer(false)}
              onKeyDown={handleKeyActivate(() => setOpenMarketDrawer(false))}
              role='button'
              tabIndex={0}
            >
              <ChevronLeft marginRight='5px' verticalAlign='-6px' />
              Back
            </div>
            <div
              className='navmob__ham'
              onClick={closeDrawer}
              onKeyDown={handleKeyActivate(closeDrawer)}
              role='button'
              tabIndex={0}
            >
              <CloseIcon size='30' />
            </div>
          </div>
          <ul className='options'>
            <li className='options__item'>
              <HouseCertificate color='#8A4743' />
              <Link onClick={closeDrawer} to='/' className='text-almost-black subhead-3 mb-0'>
                All Properties
                <p className='text-taupe-80'>Start building your wealth with Realbricks’ fractionalized real estate assets.</p>
              </Link>
            </li>
            <li className='options__item'>
              <span></span>
              <Link onClick={closeDrawer} to='/marketplace/initial' className='text-almost-black subhead-3 mb-0'>
                Initial Offerings
                <p className='text-taupe-80'>Get in early with our hand-picked investements.</p>
              </Link>
            </li>
            {isLoggedIn && !isEntityRestricted && (
              <li className='options__item'>
                <span></span>
                <Link onClick={closeDrawer} to='/marketplace/secondary' className='text-almost-black subhead-3 mb-0'>
                  Market
                  <p className='text-taupe-80'>Purchase shares of available residential properties.</p>
                </Link>
              </li>
            )}
          </ul>
          <ul className='properties'>
            <li className='properties__item'>
              <span>PROPERTY TYPES</span>
            </li>
            <li className='properties__item'>
              <Link className='fz-16 text-almost-black fw-600' href='/vacation'>
                Vacation Rentals
              </Link>
            </li>
            <li className='properties__item'>
              <Link className='fz-16 text-almost-black fw-600' href='/longterm'>
                Long-term Rentals
              </Link>
            </li>
            <li className=' mb-20 properties__item'>
              <Link className='fz-16 text-almost-black fw-600' href='/multiunit'>
                Multi-unit
              </Link>
            </li>
            <li className='properties__item'>
              <span>STATUS</span>
            </li>
            <li className='properties__item'>
              <Link className='fz-16 text-almost-black fw-600' href='/leased'>
                Leased
              </Link>
            </li>
          </ul>
        </div>
      </Drawer>
      <Drawer className='navdrawer' width={400} headerStyle={{ display: 'none' }} onClose={() => setOpenReferalDrawer(false)} open={openReferalDrawer}>
      <div className='market'>
          <div className='mb-32 navmob'>
            <div
              className='cursor-pointer text-terracotta fw-600 fz-16 navmb__back'
              onClick={() => setOpenReferalDrawer(false)}
              onKeyDown={handleKeyActivate(() => setOpenReferalDrawer(false))}
              role='button'
              tabIndex={0}
            >
              <ChevronLeft marginRight='5px' verticalAlign='-6px' />
              Back
            </div>
            <div
              className='navmob__ham'
              onClick={closeDrawer}
              onKeyDown={handleKeyActivate(closeDrawer)}
              role='button'
              tabIndex={0}
            >
              <CloseIcon size='30' />
            </div>
          </div>
          <div className='sharepop'>
      <p className='fz-14 mb-0 text-taupe-80'>Share to:</p>
      <TwitterShareButton className='d-flex g-8 align-items-center sharepop__item' url={`${bodyText} ${referallink}`}>
        <TwitterRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Share on Twitter</span>
      </TwitterShareButton>
      <FacebookShareButton url={localStorage.getItem('referralLink')} className='d-flex g-8 align-items-center sharepop__item'>
        <FacebookRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Share on Facebook</span>
      </FacebookShareButton>
      <LinkedinShareButton url={localStorage.getItem('referralLink')} className='d-flex g-8 align-items-center sharepop__item'>
        <LinkedinRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Share on LinkedIn</span>
      </LinkedinShareButton>
      <EmailShareButton
        url={`${bodyText}${localStorage.getItem('referralLink')}`}
        subject={'Real estate investment made easy'}
        // body={isHeader ? bodyText : window.location.href}
        className='d-flex g-8 align-items-center sharepop__item'
      >
        <EmailRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Send via email</span>
      </EmailShareButton>
      <a
        href={() => false}
        onClick={() => {
          copyTextToClipboard(localStorage.getItem('referralLink'));
          toastNotify('success', 'Referral Link Copied Successfully');
        }}
        className='d-flex g-8 align-items-center sharepop__item'
      >
        <CopyRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Referral Link</span>
      </a>
    </div>
        </div>
      </Drawer>
      <LogoutModal logoutModal={logoutModal} setLogoutModal={setLogoutModal} onSuccess={closeDrawer} />
    </>
  );
};

export default AccountNavMobile;
